import { initContract } from '@ts-rest/core';
const c = initContract();
export const publicOnboardingContract = c.router({
    generateProfile: {
        method: 'POST',
        path: '/public/onboarding/generate-profile',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    recommendSources: {
        method: 'POST',
        path: '/public/onboarding/recommend-sources',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    recommendRegulations: {
        method: 'POST',
        path: '/public/onboarding/recommend-regulations',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    recommendGuidances: {
        method: 'POST',
        path: '/public/onboarding/recommend-guidances',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    recommendStandards: {
        method: 'POST',
        path: '/public/onboarding/recommend-standards',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    recommendNews: {
        method: 'POST',
        path: '/public/onboarding/recommend-news',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
});
// ============ Contract ============
export const regulatoryWatchContract = c.router({
    listSources: {
        method: 'GET',
        path: '/regulatory-watch/sources',
        responses: {
            200: c.type(),
        },
    },
    listSourcesWithSubscriptions: {
        method: 'GET',
        path: '/regulatory-watch/source-subscriptions',
        responses: {
            200: c.type(),
        },
    },
    listStandardSources: {
        method: 'GET',
        path: '/regulatory-watch/standard-sources',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    listUpdates: {
        method: 'GET',
        path: '/regulatory-watch/updates',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateContextStatus: {
        method: 'PATCH',
        path: '/regulatory-watch/update-contexts/:id',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateContextAssignees: {
        method: 'PATCH',
        path: '/regulatory-watch/update-contexts/:id/assignees',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateSourceSubscriptionAssignees: {
        method: 'PATCH',
        path: '/regulatory-watch/source-subscriptions/:sourceId/assignees',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    listReferenceSubscriptions: {
        method: 'GET',
        path: '/regulatory-watch/reference-subscriptions/:sourceId',
        responses: {
            200: c.type(),
        },
    },
    updateReferenceSubscription: {
        method: 'PATCH',
        path: '/regulatory-watch/reference-subscriptions/:referenceId',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateReferenceSubscriptionAssignees: {
        method: 'PATCH',
        path: '/regulatory-watch/reference-subscriptions/:referenceId/assignees',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getProfile: {
        method: 'GET',
        path: '/regulatory-watch/profile',
        responses: {
            200: c.type(),
        },
    },
    updateProfile: {
        method: 'PATCH',
        path: '/regulatory-watch/profile',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    createProduct: {
        method: 'POST',
        path: '/regulatory-watch/products',
        body: c.type(),
        responses: {
            201: c.type(),
        },
    },
    updateProduct: {
        method: 'PATCH',
        path: '/regulatory-watch/products/:productId',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    deleteProduct: {
        method: 'DELETE',
        path: '/regulatory-watch/products/:productId',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    onboardingGenerateProfile: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-generate-profile',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    onboardingClearSubscriptions: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-clear-subscriptions',
        body: c.type(),
        responses: { 200: c.type() },
    },
    onboardingRecommendRegulations: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-recommend-regulations',
        body: c.type(),
        responses: { 200: c.type() },
    },
    onboardingRecommendGuidances: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-recommend-guidances',
        body: c.type(),
        responses: { 200: c.type() },
    },
    onboardingRecommendStandards: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-recommend-standards',
        body: c.type(),
        responses: { 200: c.type() },
    },
    onboardingRecommendNews: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-recommend-news',
        body: c.type(),
        responses: { 200: c.type() },
    },
    listReferences: {
        method: 'GET',
        path: '/regulatory-watch/references',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    bulkUpdateSubscriptions: {
        method: 'PUT',
        path: '/regulatory-watch/subscriptions',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getUpdateDetail: {
        method: 'GET',
        path: '/regulatory-watch/updates/:id',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    attachFileToVersion: {
        method: 'POST',
        path: '/regulatory-watch/versions/:versionId/attach-file',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    detachFileFromVersion: {
        method: 'DELETE',
        path: '/regulatory-watch/versions/:versionId/file/:fileId',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    generateRedline: {
        method: 'POST',
        path: '/regulatory-watch/updates/:updateId/redline',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
            400: c.type(),
        },
    },
    generateImpact: {
        method: 'POST',
        path: '/regulatory-watch/update-contexts/:id/impact',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
            400: c.type(),
        },
    },
    onboardingCompleteProfile: {
        method: 'POST',
        path: '/regulatory-watch/onboarding-complete-profile',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    exportUpdates: {
        method: 'GET',
        path: '/regulatory-watch/updates/export',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    exportUpdatesToTracex: {
        method: 'POST',
        path: '/regulatory-watch/updates/export-tracex',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
    resetOnboarding: {
        method: 'POST',
        path: '/regulatory-watch/reset-onboarding',
        body: c.type(),
        responses: {
            200: c.type(),
            403: c.type(),
        },
    },
    listAllDocuments: {
        method: 'GET',
        path: '/regulatory-watch/all-documents',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getReferenceDetail: {
        method: 'GET',
        path: '/regulatory-watch/references/:referenceId',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
});
//# sourceMappingURL=regulatoryWatch.js.map